import { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DashboardFormWrapper } from '../dashboard';
import { GateInsPage } from './GateInsComponents';
import { GateInsViewHeader, GateInsViewForm } from './GateInsViewComponents';
import { useGateInQuery } from '../../hooks';
import { RoleGuard } from '../../routes';
import { GateInReceiptPrint } from '../containers/GateInReceiptPrint';

export const GateInsView = () => {
  const params: any = useParams();
  const { data: request, isFetching } = useGateInQuery(params.id);
  const [isPrinting, setIsPrinting] = useState(false);

  if (isFetching) return <></>;
  if (!request) return <Navigate to={'/dashboard/gateins'} replace />;

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <GateInsPage>
        <GateInsViewHeader request={request} onPrint={() => setIsPrinting(true)} />
        <DashboardFormWrapper flow={'row'}>
          <GateInsViewForm request={request} />
        </DashboardFormWrapper>
      </GateInsPage>
      {isPrinting && (
        <GateInReceiptPrint container={request.container} onPrinted={() => setIsPrinting(false)} />
      )}
    </RoleGuard>
  );
};
